import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { Mutex } from 'async-mutex';

import { CHECK_AUTH_URL } from '@/env-config';

import { isAuthError, redirectToLoginPage } from './utils';

const mutex = new Mutex();

const baseQueryWithCredentials: typeof fetchBaseQuery = (args) =>
  fetchBaseQuery({
    credentials: 'include',
    prepareHeaders: (headers) => {
      headers.set('Accept', 'application/json');
      return headers;
    },
    ...args,
  });

const baseQuery: typeof fetchBaseQuery =
  (queryFactoryArgs) => async (queryArgs, api, extraOptions) => {
    await mutex.waitForUnlock();
    const query = baseQueryWithCredentials({ ...queryFactoryArgs });
    const result = await query(queryArgs, api, extraOptions);

    if (result.error && isAuthError(result.error.status)) {
      if (!mutex.isLocked()) {
        const release = await mutex.acquire();
        const authResult = await query(CHECK_AUTH_URL, api, extraOptions);
        if (authResult.error && isAuthError(authResult.error.status)) {
          redirectToLoginPage();
        } else {
          release();
        }
      } else {
        await mutex.waitForUnlock();
      }
    }
    return result;
  };

export { baseQuery };
